import { RouterProvider } from 'react-router';
import { ConfigProvider, App as AntdApp, theme } from 'antd';
import { router } from '@/router';
import './App.scss';

const darkTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#3b82f6',
    colorBgContainer: '#141b2d',
    colorBgElevated: '#1a2332',
    colorBgLayout: '#0a0e17',
    colorBorder: '#253244',
    colorBorderSecondary: '#1e293b',
    colorText: '#e8eaed',
    colorTextSecondary: '#8b95a5',
    colorTextTertiary: '#5f6b7a',
    colorSuccess: '#22c55e',
    colorError: '#ef4444',
    colorWarning: '#f59e0b',
    borderRadius: 6,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
  },
  components: {
    Card: {
      colorBgContainer: '#141b2d',
      colorBorderSecondary: '#253244',
    },
    Table: {
      colorBgContainer: '#141b2d',
      headerBg: '#111827',
      rowHoverBg: '#1a2332',
    },
    Modal: {
      contentBg: '#141b2d',
      headerBg: '#141b2d',
    },
    Drawer: {
      colorBgElevated: '#141b2d',
    },
    Descriptions: {
      colorBgContainer: '#111827',
      colorSplit: '#253244',
    },
  },
};

const App = () => {
  return (
    <ConfigProvider theme={darkTheme}>
      <AntdApp>
        <RouterProvider router={router} />
      </AntdApp>
    </ConfigProvider>
  );
};

export default App;
